import React, { useEffect, useState, useContext, useCallback } from 'react'
import _ from 'lodash'
import classNames from 'classnames'

import AppConfigContext from '../app_layout/app_config_context'
import { ApiHelper } from '../../helpers/apihelper'
import * as Constants from '../../helpers/constants'

import UserInfoCard from './components/user_card'

const OtherUsersList = ({
  planId,
  attachedUserIds = [],
  product,
  onAttachSuccess,
  onCancelSuccess
}) => {

  const { client } = useContext(AppConfigContext)
  const [userList, setUserList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const fetchUsers = useCallback(({ search = '' } = {}) => {
    if (!client) return
    setIsLoading(true)
    const getUserList = ApiHelper(client, 'USER_LIST')
    const requestBody = _.pick(
      {
        skip: 0,
        limit: 10,
        search,
        filters: {},
        client_secret: Constants.CLIENT_SECRET
      },
      getUserList.API_BODY
    )
    getUserList.API(client, requestBody)
      .then(listResponse => {

        if (listResponse.status !== Constants.CO_API.SUCCESS) {
          setUserList([])
          return
        }
        const users = listResponse.data.data || []
        setUserList(users)
      })
      .catch(error => {
        console.error(error)
        setUserList([])
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [client])
  useEffect(() => {
    fetchUsers({})
  }, [fetchUsers, attachedUserIds])

  const attachedSet = new Set(
    attachedUserIds.map(id => String(id))
  )

  const filteredUsers = userList.filter(
    user => !attachedSet.has(String(user._id))
  )

  const handleSearchChange = (e) => {
    const value = e.target.value
    setSearchQuery(value)
    fetchUsers({ search: value })
  }
  
  const handleAttachSuccess = (userId) => {
    fetchUsers({ search: searchQuery })
    if (onAttachSuccess) {
      onAttachSuccess(userId)
    }
  }
  const handleCancelSuccess = (userId) => {
    fetchUsers({ search: searchQuery })
    if (onCancelSuccess) {
      onCancelSuccess(userId)
    }
  }
  return (
    <div
      className="product-other-users-container product-other-users-spacing"
    >
      <div className="product-other-users-header">
        <div>
          <div className="product-users-title">
            Other Users
          </div>
          <div className="product-users-description">
            Search and manage users
          </div>
        </div>
        <div
          className={classNames(
            'product-other-users-search-wrapper',
            { 'search-active': searchQuery.length > 0 }
          )}
        >
          <input
            type="text"
            className="product-other-users-search-input"
            placeholder="Search users..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>

      </div>
      <div
        className="product-other-users-body"
      >
        {isLoading && (
          <div className="product-other-users-empty">
            Loading users...
          </div>
        )}
        {!isLoading && filteredUsers.length === 0 && (
          <div className="product-other-users-empty">
            No users found
          </div>
        )}
        {!isLoading &&
          filteredUsers.map(user => (
            <UserInfoCard
              key={user._id}
              user={user}
              userId={user._id}
              planId={planId}
              attachedUserIds={attachedUserIds}
              product={product}
              onAttachSuccess={handleAttachSuccess}
              onCancelSuccess={handleCancelSuccess}
            />
          ))
        }
      </div>
    </div>
  )
}

export default OtherUsersList